import './FloatingButtons.scss'
import { navigateTo } from '../../../common/navigation'
import { useHistory } from 'react-router-dom'
import {
  ROUTE_ACTIVITIES_JOURNALING_CREATE_JOURNAL,
  ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL
} from '../../../common/helpers/Paths'

export default function FloatingButtons() {
  const history = useHistory()

  const actionToggle = () => {
    const action = document.querySelector('.action')
    action.classList.toggle('active')
  }

  const listItems = [
    {
      text: 'My Journal',
      route: ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL
    },
    {
      text: 'New entry',
      route: ROUTE_ACTIVITIES_JOURNALING_CREATE_JOURNAL
    }
  ]

  return (
    <div className='container floating-button'>
      <div
        className='action cursor-pointer bg-white rounded-circle position-fixed align-center flex-column text-center'
        onClick={actionToggle}
      >
        <i className='bi bi-journal-bookmark bi-lg w-100'></i>
        <span>Journal</span>
        <ul className='position-absolute bg-white p-4 rounded-4'>
          {listItems.map(({ text, route }) => (
            <li
              key={text}
              className='text-left py-2'
              onClick={_ => navigateTo(route, history)}
            >
              {text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
